module.exports = __webpack_public_path__ + "img/1508256796.5a1144ea.jpg";